import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageAssets({user,myVulns}){
  var T=React.useContext(ThemeCtx).T;
  var _ap=useState(1); var aPage=_ap[0]; var setAPage=_ap[1];
  var _assets=useState([]); var assets=_assets[0]; var setAssets=_assets[1];
  var _loading=useState(true); var loading=_loading[0]; var setLoading=_loading[1];
  var _search=useState(""); var search=_search[0]; var setSearch=_search[1];
  var _envFilter=useState(""); var envFilter=_envFilter[0]; var setEnvFilter=_envFilter[1];
  var PURPLE="#A100FF";
  var canEdit=user&&["admin","lead"].includes(user.role);
  var _critFilter=useState(""); var critFilter=_critFilter[0]; var setCritFilter=_critFilter[1];
  var _envFilter2=useState(""); var envFilter2=_envFilter2[0]; var setEnvFilter2=_envFilter2[1];
  var _showModal=useState(false); var showModal=_showModal[0]; var setShowModal=_showModal[1];
  var _editAsset=useState(null); var editAsset=_editAsset[0]; var setEditAsset=_editAsset[1];
  var _users=useState([]); var users=_users[0]; var setUsers=_users[1];
  var _pods=useState([]); var pods=_pods[0]; var setPods=_pods[1];
  var _form=useState({name:"",type:"Server",environment:"Production",criticality:"High",os:"",ip:"",owner_id:"",pod_id:"",internet_facing:false,sensitive_data:"None",regulatory_scope:"None"});
  var form=_form[0]; var setForm=_form[1];
  var _saving=useState(false); var saving=_saving[0]; var setSaving=_saving[1];
  var _msg=useState(""); var assetMsg=_msg[0]; var setAssetMsg=_msg[1];

  var loadAssets=function(){ api.get("/assets").then(setAssets).catch(function(){}).finally(function(){setLoading(false);}); };
  useEffect(function(){
    loadAssets();
    api.get("/users").then(setUsers).catch(function(){});
    api.get("/pods").then(setPods).catch(function(){});
  },[]);

  var openAdd=function(){
    setEditAsset(null);
    setForm({name:"",type:"Server",environment:"Production",criticality:"High",os:"",ip:"",owner_id:"",pod_id:""});
    setAssetMsg(""); setShowModal(true);
  };
  var openEdit=function(a){
    setEditAsset(a);
    setForm({name:a.name,type:a.type||"Server",environment:a.environment||"Production",
      criticality:a.criticality||"High",os:a.os_version||"",ip:a.ip_address||"",
      owner_id:a.owner_id||"",pod_id:a.pod_id||"",
      internet_facing:!!a.internet_facing,
      sensitive_data:a.sensitive_data||"None",
      regulatory_scope:a.regulatory_scope||"None",
      compensating_controls:Array.isArray(a.compensating_controls)?a.compensating_controls:[]});
    setAssetMsg(""); setShowModal(true);
  };
  var saveAsset=async function(){
    if(!form.name.trim()||!form.criticality){setAssetMsg("Name and criticality required");return;}
    setSaving(true);
    try{
      if(editAsset){
        await api.patch("/assets/"+editAsset.id,{name:form.name,type:form.type,
          environment:form.environment,criticality:form.criticality,
          os_version:form.os,ip_address:form.ip,
          owner_id:form.owner_id||null,pod_id:form.pod_id||null,
          internet_facing:!!form.internet_facing,
          sensitive_data:form.sensitive_data||"None",
          regulatory_scope:form.regulatory_scope||"None",
          compensating_controls:JSON.stringify(form.compensating_controls||[])});
      } else {
        await api.post("/assets",{name:form.name,type:form.type,
          environment:form.environment,criticality:form.criticality,
          os:form.os,ip:form.ip,
          owner_id:form.owner_id||null,pod_id:form.pod_id||null,
          internet_facing:!!form.internet_facing,
          sensitive_data:form.sensitive_data||"None",
          regulatory_scope:form.regulatory_scope||"None",
          compensating_controls:JSON.stringify(form.compensating_controls||[])});
      }
      setShowModal(false); loadAssets();
    }catch(e){setAssetMsg(e.message);}
    setSaving(false);
  };
  var deleteAsset=async function(a){
    if(!window.confirm("Delete asset "+a.name+"? This will not delete associated vulnerabilities.")) return;
    try{ await api.delete("/assets/"+a.id); loadAssets(); }
    catch(e){ alert(e.message); }
  };

  useEffect(function(){
    api.get("/assets").then(setAssets).catch(function(){}).finally(function(){setLoading(false);});
  },[]);

  var filtered=assets.filter(function(a){
    if(envFilter && a.environment!==envFilter) return false;
    if(critFilter==="critical" && a.criticality!=="Critical") return false;
    if(critFilter==="production" && a.environment!=="Production") return false;
    if(critFilter==="withvulns" && !myVulns.some(function(v){return v.asset===a.name&&v.status!=="Remediated";})) return false;
    if(critFilter==="internet" && !a.internet_facing) return false;
    if(critFilter==="noowner" && a.owner_id) return false;
    if(search && !(a.name+(a.description||"")+(a.type||"")).toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  // Get vuln severity counts per asset
  var getVulnCounts=function(assetName){
    var av=myVulns.filter(function(v){return v.asset===assetName&&v.status!=="Remediated";});
    var c={C:av.filter(function(v){return v.severity==="Critical";}).length,
           H:av.filter(function(v){return v.severity==="High";}).length,
           M:av.filter(function(v){return v.severity==="Medium";}).length,
           L:av.filter(function(v){return v.severity==="Low";}).length,total:av.length};
    return c;
  };

  // Get scanner names per asset
  var getScanners=function(assetName){
    var scanners=[...new Set(myVulns.filter(function(v){return v.asset===assetName;})
      .map(function(v){return v.scanner_name;}).filter(Boolean))];
    return scanners.slice(0,2).join(", ")||"—";
  };

  var critColor={"Critical":"#e5534b","High":"#e8892b","Medium":"#c69026","Low":"#2ea043"};
  var thS={padding:"10px 12px",textAlign:"left",fontSize:10,fontWeight:700,color:T.text3,
    textTransform:"uppercase",letterSpacing:.8,background:T.inset,
    borderBottom:"1px solid "+T.border,whiteSpace:"nowrap"};
  var tdS={padding:"10px 12px",fontSize:12,color:T.text,borderBottom:"1px solid "+T.border,verticalAlign:"middle"};

  if(loading) return React.createElement("div",{style:{padding:40,color:T.text3,textAlign:"center"}},"Loading assets...");

  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:14}},

    // Summary cards
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:10}},
      [{l:"Total",v:assets.length,c:PURPLE,f:""},
       {l:"Critical",v:assets.filter(function(a){return a.criticality==="Critical";}).length,c:"#e5534b",f:"critical"},
       {l:"Production",v:assets.filter(function(a){return a.environment==="Production";}).length,c:"#e8892b",f:"production"},
       {l:"With Vulns",v:assets.filter(function(a){return getVulnCounts(a.name).total>0;}).length,c:"#d29922",f:"withvulns"},
       {l:"Internet Facing",v:assets.filter(function(a){return a.internet_facing;}).length,c:"#dc2626",f:"internet"},
       {l:"No Owner",v:assets.filter(function(a){return !a.owner_id;}).length,c:"#f97316",f:"noowner"},
      ].map(function(s){
        var active=critFilter===s.f&&s.f!=="";
        return React.createElement("div",{key:s.l,
          onClick:function(){setCritFilter(active?"":s.f);},
          style:{background:T.card,border:"2px solid "+(active?s.c:T.border),
            borderRadius:12,padding:"14px 16px",boxShadow:T.cardShadow,
            cursor:s.f?"pointer":"default",transition:"all .15s"}},
          React.createElement("div",{style:{fontSize:24,fontWeight:800,color:s.c}},s.v),
          React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:2}},s.l)
        );
      })
    ),

    // Filters
    React.createElement("div",{style:{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}},
      React.createElement("input",{placeholder:"Search assets...",value:search,
        onChange:function(e){setSearch(e.target.value);},
        style:{flex:"1 1 200px",padding:"8px 12px",background:T.inset,border:"1px solid "+T.border,
          color:T.text,fontSize:13,outline:"none",borderRadius:8}}),
      React.createElement("select",{value:envFilter,onChange:function(e){setEnvFilter(e.target.value);},
        style:{padding:"8px 12px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:12,outline:"none",borderRadius:8}},
        React.createElement("option",{value:""},"All Environments"),
        ["Production","Dev/UAT","Staging","DR"].map(function(e){
          return React.createElement("option",{key:e,value:e},e);
        })
      ),
      React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10}},
        React.createElement("span",{style:{fontSize:12,color:T.text3}},filtered.length+" assets"),
        filtered.length>PAGE_SIZE&&React.createElement("div",{style:{display:"flex",gap:4}},
          React.createElement("button",{onClick:function(){setAPage(function(p){return Math.max(1,p-1);});},disabled:aPage<=1,
            style:{padding:"2px 8px",background:T.inset,border:"1px solid "+T.border,borderRadius:4,cursor:"pointer",fontSize:11,color:T.text2,opacity:aPage<=1?0.4:1}},"< Prev"),
          React.createElement("span",{style:{fontSize:11,color:T.text3}},aPage+"/"+Math.ceil(filtered.length/PAGE_SIZE)),
          React.createElement("button",{onClick:function(){setAPage(function(p){return Math.min(Math.ceil(filtered.length/PAGE_SIZE),p+1);});},disabled:aPage>=Math.ceil(filtered.length/PAGE_SIZE),
            style:{padding:"2px 8px",background:T.inset,border:"1px solid "+T.border,borderRadius:4,cursor:"pointer",fontSize:11,color:T.text2,opacity:aPage>=Math.ceil(filtered.length/PAGE_SIZE)?0.4:1}},"Next >")
        )
      ),
      canEdit&&React.createElement("button",{onClick:openAdd,
        style:{background:PURPLE,color:"#fff",border:"none",borderRadius:8,
          padding:"8px 16px",cursor:"pointer",fontSize:12,fontWeight:600,marginLeft:"auto"}},
        "+ New Asset")
    ),

    // Table
    React.createElement("div",{style:{background:T.card,borderRadius:12,overflow:"hidden",boxShadow:T.cardShadow}},
      React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
        React.createElement("thead",null,
          React.createElement("tr",null,
            [...["Asset Name","Description","Type","Environment","Criticality","Owner","Open Vulns","Scanners","Scan Status"],...(canEdit?["Actions"]:[])] .map(function(h){
              return React.createElement("th",{key:h,style:thS},h);
            })
          )
        ),
        React.createElement("tbody",null,
          filtered.length===0
            ? React.createElement("tr",null,React.createElement("td",{colSpan:9,style:{padding:32,textAlign:"center",color:T.text3}},"No assets found"))
            : filtered.slice((aPage-1)*PAGE_SIZE,aPage*PAGE_SIZE).map(function(a,i){
                var vc=getVulnCounts(a.name);
                var scanners=getScanners(a.name);
                var critColor2={"Critical":"#e5534b","High":"#e8892b","Medium":"#c69026","Low":"#2ea043"}[a.criticality]||T.text3;
                var scanColor=a.scan_status==="OK"?"#2ea043":a.scan_status==="Error"?"#e5534b":"#d29922";
                return React.createElement("tr",{key:a.id,style:{background:i%2===0?T.card:T.inset}},
                  // Asset name
                  React.createElement("td",{style:Object.assign({},tdS,{fontWeight:600,color:PURPLE})},a.name),
                  // Description
                  React.createElement("td",{style:Object.assign({},tdS,{color:T.text2,maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"})},
                    a.os_version||a.type||"—"),
                  // Type
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:PURPLE+"15",color:PURPLE,padding:"2px 8px",borderRadius:20,fontSize:11}},a.type||"—")
                  ),
                  // Environment
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:T.inset,color:T.text2,padding:"2px 8px",borderRadius:20,fontSize:11,border:"1px solid "+T.border}},a.environment||"—")
                  ),
                  // Criticality
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:critColor2+"20",color:critColor2,padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:700}},a.criticality)
                  ),
                  // Owner
                  React.createElement("td",{style:Object.assign({},tdS,{color:T.text2})},a.owner_name||"—"),
                  // Open Vulns C/H/M/L
                  React.createElement("td",{style:tdS},
                    vc.total===0
                      ? React.createElement("span",{style:{color:"#2ea043",fontSize:11}},"Clean")
                      : React.createElement("div",{style:{display:"flex",gap:4,flexWrap:"wrap"}},
                          vc.C>0&&React.createElement("span",{style:{background:"#e5534b20",color:"#e5534b",padding:"1px 6px",borderRadius:4,fontSize:11,fontWeight:700}},"C:"+vc.C),
                          vc.H>0&&React.createElement("span",{style:{background:"#e8892b20",color:"#e8892b",padding:"1px 6px",borderRadius:4,fontSize:11,fontWeight:700}},"H:"+vc.H),
                          vc.M>0&&React.createElement("span",{style:{background:"#c6902620",color:"#c69026",padding:"1px 6px",borderRadius:4,fontSize:11,fontWeight:700}},"M:"+vc.M),
                          vc.L>0&&React.createElement("span",{style:{background:"#2ea04320",color:"#2ea043",padding:"1px 6px",borderRadius:4,fontSize:11,fontWeight:700}},"L:"+vc.L)
                        )
                  ),
                  // Scanners
                  React.createElement("td",{style:Object.assign({},tdS,{color:T.text3,fontSize:11})},scanners),
                  // Scan status
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:scanColor+"20",color:scanColor,padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:700}},
                      a.scan_status||"Unknown")
                  ),
                  // Actions
                  canEdit&&React.createElement("td",{style:tdS},
                    React.createElement("div",{style:{display:"flex",gap:6}},
                      React.createElement("button",{onClick:function(){openEdit(a);},
                        style:{background:PURPLE+"18",color:PURPLE,border:"1px solid "+PURPLE+"44",
                          borderRadius:6,padding:"4px 10px",cursor:"pointer",fontSize:11,fontWeight:600}},
                        "Edit"),
                      React.createElement("button",{onClick:function(){deleteAsset(a);},
                        style:{background:"#e5534b18",color:"#e5534b",border:"1px solid #e5534b44",
                          borderRadius:6,padding:"4px 10px",cursor:"pointer",fontSize:11,fontWeight:600}},
                        "Delete")
                    )
                  )
                );
              })
        )
      )
    ),

    // Add/Edit Modal
    showModal&&React.createElement(Modal,{title:(editAsset?"Edit":"Add")+" Asset",onClose:function(){setShowModal(false);}},
      assetMsg&&React.createElement("div",{style:{background:"#e5534b18",color:"#e5534b",borderRadius:6,padding:"8px 12px",fontSize:12,marginBottom:10}},assetMsg),
      React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}},
        [["Asset Name","name","text"],["IP Address","ip","text"],["OS / Version","os","text"],["Type","type","select"]].map(function(f){
          return React.createElement("div",{key:f[1]},
            React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},f[0]),
            f[2]==="select"
              ? React.createElement("select",{value:form[f[1]],onChange:function(e){setForm(function(p){return Object.assign({},p,{[f[1]]:e.target.value});});},
                  style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"}},
                  ["Server","Firewall","API Gateway","CI/CD","Remote","File Server","Database","Application","Network","Cloud","Container","Other"].map(function(o){
                    return React.createElement("option",{key:o,value:o},o);
                  }))
              : React.createElement("input",{type:"text",value:form[f[1]],
                  onChange:function(e){setForm(function(p){return Object.assign({},p,{[f[1]]:e.target.value});});},
                  style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"}})
          );
        })
      ),
      React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginTop:10}},
        React.createElement("div",null,
          React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Environment"),
          React.createElement("select",{value:form.environment,onChange:function(e){setForm(function(p){return Object.assign({},p,{environment:e.target.value});});},
            style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"}},
            ["Production","Dev/UAT","Staging","DR"].map(function(o){return React.createElement("option",{key:o,value:o},o);}))
        ),
        React.createElement("div",null,
          React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Criticality"),
          React.createElement("select",{value:form.criticality,onChange:function(e){setForm(function(p){return Object.assign({},p,{criticality:e.target.value});});},
            style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"}},
            ["Critical","High","Medium","Low"].map(function(o){return React.createElement("option",{key:o,value:o},o);}))
        ),
        React.createElement("div",null,
          React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Owner"),
          React.createElement("select",{value:form.owner_id,onChange:function(e){setForm(function(p){return Object.assign({},p,{owner_id:e.target.value});});},
            style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"}},
            React.createElement("option",{value:""},"— No owner —"),
            users.map(function(u){return React.createElement("option",{key:u.id,value:u.id},u.name+" ("+u.role+")");}))
        ),
        React.createElement("div",null,
          React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Pod"),
          React.createElement("select",{value:form.pod_id,onChange:function(e){setForm(function(p){return Object.assign({},p,{pod_id:e.target.value});});},
            style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"}},
            React.createElement("option",{value:""},"— No pod —"),
            pods.map(function(p){return React.createElement("option",{key:p.id,value:p.id},p.name);}))
        )
      ),
        React.createElement("div",{style:{marginTop:10}},
          React.createElement("div",{style:{fontSize:12,fontWeight:600,color:T.text,marginBottom:8}},"Risk Context"),
          React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}},
            React.createElement("div",null,
              React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Sensitive Data"),
              React.createElement("select",{value:form.sensitive_data||"None",onChange:function(e){setForm(function(p){return Object.assign({},p,{sensitive_data:e.target.value});});},
                style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"}},
                ["None","PII","Financial","IP"].map(function(o){return React.createElement("option",{key:o,value:o},o);}))),
            React.createElement("div",null,
              React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Regulatory Scope"),
              React.createElement("select",{value:form.regulatory_scope||"None",onChange:function(e){setForm(function(p){return Object.assign({},p,{regulatory_scope:e.target.value});});},
                style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"}},
                ["None","PCI","HIPAA","ISO","SOC2"].map(function(o){return React.createElement("option",{key:o,value:o},o);})))
          ),
          React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8,marginTop:8,background:T.inset,borderRadius:8,padding:"10px 14px"}},
            React.createElement("input",{type:"checkbox",id:"chk_internet",checked:!!form.internet_facing,
              onChange:function(e){setForm(function(p){return Object.assign({},p,{internet_facing:e.target.checked});});},
              style:{width:16,height:16,accentColor:"#DC2626"}}),
            React.createElement("label",{htmlFor:"chk_internet",style:{fontSize:12,fontWeight:600,color:T.text,cursor:"pointer"}},
              "\uD83C\uDF10 Internet-facing — applies exposure multiplier to risk score")
          )
        ),
        React.createElement("div",{style:{marginTop:10}},
          React.createElement("div",{style:{fontSize:12,fontWeight:600,color:T.text,marginBottom:8}},"Risk Context"),
          React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}},
            React.createElement("div",null,
              React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Sensitive Data"),
              React.createElement("select",{value:form.sensitive_data||"None",onChange:function(e){setForm(function(p){return Object.assign({},p,{sensitive_data:e.target.value});});},
                style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"}},
                ["None","PII","Financial","IP"].map(function(o){return React.createElement("option",{key:o,value:o},o);}))),
            React.createElement("div",null,
              React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Regulatory Scope"),
              React.createElement("select",{value:form.regulatory_scope||"None",onChange:function(e){setForm(function(p){return Object.assign({},p,{regulatory_scope:e.target.value});});},
                style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"}},
                ["None","PCI","HIPAA","ISO","SOC2"].map(function(o){return React.createElement("option",{key:o,value:o},o);})))
          ),
          React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:6,marginTop:8}},"Compensating Controls"),
          React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6}},
            [["WAF","WAF −10%"],["EDR","EDR −10%"],["IPS","IPS −10%"],
             ["NET_ISOLATION","Net Isolation −15%"],["MFA","MFA −5%"],
             ["ENCRYPTION","Encryption −5%"],["PAM","PAM −5%"]].map(function(ctrl){
              var checked=(form.compensating_controls||[]).includes(ctrl[0]);
              return React.createElement("div",{key:ctrl[0],
                onClick:function(){setForm(function(p){
                  var cc=p.compensating_controls||[];
                  return Object.assign({},p,{compensating_controls:checked?cc.filter(function(x){return x!==ctrl[0];}):cc.concat(ctrl[0])});
                });},
                style:{display:"flex",alignItems:"center",gap:6,padding:"6px 8px",
                  background:checked?T.accent+"18":T.inset,border:"1px solid "+(checked?T.accent:T.border),
                  borderRadius:6,cursor:"pointer",fontSize:10,fontWeight:checked?700:400,
                  color:checked?T.accent:T.text2}},
                React.createElement("span",{style:{fontSize:12}},checked?"☑":"☐"),ctrl[1]);
            })
          ),
          React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8,marginTop:8,background:T.inset,borderRadius:8,padding:"10px 14px"}},
            React.createElement("input",{type:"checkbox",id:"chk_internet",checked:!!form.internet_facing,
              onChange:function(e){setForm(function(p){return Object.assign({},p,{internet_facing:e.target.checked});});},
              style:{width:16,height:16,accentColor:"#DC2626"}}),
            React.createElement("label",{htmlFor:"chk_internet",style:{fontSize:12,fontWeight:600,color:T.text,cursor:"pointer"}},
              "\uD83C\uDF10 Internet-facing — applies "+"1.50× exposure multiplier")
          )
        ),
      React.createElement("div",{style:{display:"flex",justifyContent:"flex-end",gap:8,marginTop:16}},
        React.createElement("button",{onClick:function(){setShowModal(false);},
          style:{padding:"8px 18px",background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:8,cursor:"pointer",fontSize:12}},
          "Cancel"),
        React.createElement("button",{onClick:saveAsset,disabled:saving,
          style:{padding:"8px 18px",background:PURPLE,color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontSize:12,fontWeight:600,opacity:saving?0.6:1}},
          saving?"Saving...":editAsset?"Update Asset":"Add Asset")
      )
    )
  );
}
